import React from 'react';

interface FieldErrorProps {
  error: string | null;
  className?: string;
}

const FieldError: React.FC<FieldErrorProps> = ({ error, className = '' }) => {
  if (!error) return null;

  return (
    <p className={`mt-1 text-sm text-red-600 ${className}`}>
      {error}
    </p>
  );
};

export default FieldError; 